import { Controller } from "@hotwired/stimulus"
import { setHidden, isHidden } from "../lib/display_toggle"

export default class extends Controller {
  static targets = ["input", "container", "section", "item"]
  static values = { debounceMs: { type: Number, default: 150 } }

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  search() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    this.debounceTimer = setTimeout(() => {
      this.performSearch()
    }, this.debounceMsValue)
  }

  performSearch() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (query === "") {
      // Show all items and sections
      this.itemTargets.forEach(item => setHidden(item, false))
      if (this.hasSectionTarget) {
        this.sectionTargets.forEach(section => setHidden(section, false))
      }
      return
    }

    // Filter items by title and description
    this.itemTargets.forEach(item => {
      const title = (item.dataset.title || "").toLowerCase()
      const description = (item.dataset.description || "").toLowerCase()
      const content = item.textContent.toLowerCase()

      const matchesSearch = title.includes(query) ||
                           description.includes(query) ||
                           content.includes(query)

      // Class toggle, not inline display: the link rows carry `d-flex`, which
      // beats an inline `display: none` (#12284 — see lib/display_toggle.js).
      setHidden(item, !matchesSearch)
    })

    // Hide sections with no visible items (if sections exist). Match on the
    // controller's own `item` targets rather than a CSS class — the markup class
    // has changed before (Bootstrap .list-group-item -> .gl-list-group-item),
    // which silently disabled this whole branch while the spec kept passing.
    if (this.hasSectionTarget) {
      // Resolved once: a Stimulus target getter re-queries the DOM on every
      // access, so reading itemTargets inside the section loop would repeat it
      // per section.
      const visibleItems = this.itemTargets.filter(item => !isHidden(item))

      this.sectionTargets.forEach(section => {
        setHidden(section, !visibleItems.some(item => section.contains(item)))
      })
    }
  }
}
